import { User } from "@/redux/user.types"
import { v4 as uuid } from "uuid"

export const ESTABLISHMENT_ENTITY = "establishment"

export interface EstablishmentPlan {
  id: string
  name: string
}

export interface Establishment {
  id: string
  name: string
  industryCode: string //naf
  address: string
  OrganizationId: string
  AccountId: string | null
  establishmentId: string //siret
  plans: EstablishmentPlan[]
  Users: User[]
}

/**
 * Crée un Establishment vide, avec possibilité de surcharger les valeurs.
 */
export const createEmptyEstablishment = (overrides?: Partial<Establishment> & { users?: User[] }): Establishment => ({
  id: uuid(),
  name: "",
  establishmentId: "",
  industryCode: "",
  address: "",
  OrganizationId: "",
  AccountId: null,
  ...overrides,
  plans: [],
  Users: []
})
